import { CancelToken } from 'axios'
import apiInstance from '../../backend-api.setup'
import { CatalogInterface } from '../../../interface/rank/catalog.interface'
import { ApiPathConfig } from '../../../config/ApiPathConfig'

export const getPopularClilCatalogs = (cancelToken?: CancelToken) =>
  apiInstance.get<CatalogInterface[]>(ApiPathConfig.POPULAR_CLIL_CATALOGS, {
    cancelToken,
  })
